import { createBrowserRouter } from "react-router-dom";
import MainLayout from "../Layout/MainLayout";
import Home from "../page/Home";
import Blog from "../page/Blog";
import BlogDetail from "../page/BlogDetail";
import NotFound from "../page/NotFound";
import Login from "../page/Auth/Login";
import Signup from "../page/Auth/Signup";
import Profile from "../page/Profile";
import AdminLayout from "../Layout/AdminLayout";
import Users from "../page/AdminDashboard/Users";
import Coupons from "../page/AdminDashboard/Coupons";
import Settings from "../page/AdminDashboard/Settings";

import AdminRoute from "./AdminRoute";
import PrivateRoutes from "./PrivateRoutes";
import Dashboard from "../page/AdminDashboard/Dashboard";
import Sales from "../page/AdminDashboard/Sales";
import Promotions from "../page/AdminDashboard/Promotions";


export const router = createBrowserRouter([
    {
        path: "/",
        element: <MainLayout />,
        children: [
            {
                index: true,
                element: <Home />
            },
            {
                path: "blog",
                element: <Blog />
            },
            {
                path: "blog/:slug",
                element: <BlogDetail />
            },
            {
                path: "login",
                element: <Login />
            },
            {
                path: "signup",
                element: <Signup />
            },
            {
                path: "profile",
                element: <PrivateRoutes>
                    <Profile />
                </PrivateRoutes>
            },
            {
                path: "*",
                element: <NotFound />
            }
        ]
    },
    {
        path: "/admin-dashboard",
        element:
            <AdminRoute>
                <AdminLayout />
            </AdminRoute>,
        children: [
            { index: true, element: <Dashboard /> },
            { path: "users", element: <Users /> },
            { path: "coupons", element: <Coupons /> },
            { path: "settings", element: <Settings /> },
            { path: "sales", element: <Sales /> },
            { path: "promotions", element: <Promotions /> },
        ],
    },
]);
